<header>
  <mat-toolbar class="bg-white">
    <div class="row">
      <div class="col-xs-2  hidden-md hidden-lg">
        <button mat-icon-button aria-label="Menu"  [matMenuTriggerFor]="headerMenu" >
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="col-xs-8 col-md-11">
        <a [routerLink]="linkHome"><img src="/assets/logo-posso-agendar.svg" alt="Posso Agendar?" class="menu-img" /> </a>  
      </div>
      <div class="col-1 text-right  hidden-xs hidden-sm">
        <button mat-icon-button aria-label="Menu"  [matMenuTriggerFor]="userHeaderMenu" hidden-md hidden-lg>
          <img [src]="user.photo" [alt]="user.name" *ngIf="user.photo" class="user-image"/>
          <mat-icon  *ngIf="!user.photo" class="user-icon">account_circle</mat-icon> <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #userHeaderMenu="matMenu">
          <div class="user-name" *ngIf="user.name">{{ user.name }}</div>
          <button mat-menu-item (click)="sair()">
            <mat-icon>logout</mat-icon>
            <span>Sair</span>
          </button> 
        </mat-menu>       
      </div>
    </div>       
  </mat-toolbar>
  <mat-menu #headerMenu="matMenu">
    <ng-container  *ngFor="let menu of menus">
      <button mat-menu-item  [routerLink]="menu.page" >
        <mat-icon color="primary">{{menu.icon}}</mat-icon>
        <span> {{ menu.name }}</span>
      </button>         
    </ng-container> 
    <button mat-menu-item (click)="sair()">
      <mat-icon>logout</mat-icon>
      <span>Sair</span>
    </button> 
  </mat-menu> 
</header>
